import React from 'react'
import {
  CCol,
  CFormFeedback,
  CFormLabel,
  CFormSelect,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro'
import InfoTooltip from './InfoTooltip'

const PlayerSelectionMode = ({ values, errors, touched, onChange, isTeamExists }) => (
  <>
    <CRow className="g-3">
      <CCol md={6}>
        <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="player_selection_mode">
          Player Selection Mode
          <InfoTooltip content="Position Free lets members pick any role for any spot. Position Based requires specific role limits (batsman, bowler, all-rounder, wicket keeper)." />
        </CFormLabel>
        <CFormSelect
          id="player_selection_mode"
          value={values.player_selection_mode}
          onChange={(e) => onChange('player_selection_mode', e.target.value)}
          disabled={isTeamExists}
        >
          <option value="free">Position Free (Any Role)</option>
          <option value="based">Position Based (By Role)</option>
        </CFormSelect>
      </CCol>
    </CRow>

    {values.player_selection_mode === 'based' && (
      <>
        <hr />
        <h6 className="fw-bold">Position Selection Limits</h6>
        <small className="text-medium-emphasis d-block mb-3">
          Set the minimum and maximum number of players a member can pick for each position.
        </small>
        <CRow className="g-3">
          {[
            ['min_bat', 'max_bat', 'Batsman'],
            ['min_bowl', 'max_bowl', 'Bowler'],
            ['min_ar', 'max_ar', 'All-Rounder'],
            ['min_wk', 'max_wk', 'Wicket Keeper'],
          ].map(([minKey, maxKey, label]) => (
            <CCol md={6} key={minKey}>
              <CFormLabel className="fw-bold">{label}</CFormLabel>
              <CRow className="g-2">
                <CCol xs={6}>
                  <CInputGroup className="has-validation">
                    <CInputGroupText>Min</CInputGroupText>
                    <CFormInput
                      disabled={isTeamExists}
                      invalid={!!(errors[minKey] && touched[minKey])}
                      value={values[minKey]}
                      onChange={(e) => onChange(minKey, e.target.value)}
                    />
                    {errors[minKey] && touched[minKey] && (
                      <CFormFeedback invalid>{errors[minKey]}</CFormFeedback>
                    )}
                  </CInputGroup>
                </CCol>
                <CCol xs={6}>
                  <CInputGroup className="has-validation">
                    <CInputGroupText>Max</CInputGroupText>
                    <CFormInput
                      disabled={isTeamExists}
                      invalid={!!(errors[maxKey] && touched[maxKey])}
                      value={values[maxKey]}
                      onChange={(e) => onChange(maxKey, e.target.value)}
                    />
                    {errors[maxKey] && touched[maxKey] && (
                      <CFormFeedback invalid>{errors[maxKey]}</CFormFeedback>
                    )}
                  </CInputGroup>
                </CCol>
              </CRow>
            </CCol>
          ))}
        </CRow>
      </>
    )}
  </>
)

export default PlayerSelectionMode
